<ion-header class="ion-no-border page">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title mode="ios">
      <div  (click)="goHome()" class="header-logo">&nbsp;</div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="showMenu()" class="menu" [attr.aria-label]="'ARIA.MENU.BUTTON.LABEL_0' | translate">
        <ion-icon slot="icon-only" aria-hidden="true"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="page-title" translate>SEARCH.TITLE</div>

</ion-header>

<ion-content no-bounce scroll>

  <ion-searchbar #searchbar show-clear-button="focus" [debounce]="1000" (ionInput)="handleInput($event)" 
    [placeholder]="'SEARCH.PLACEHOLDER' | translate" [value]="searchValue"></ion-searchbar>

  <coll-panel *ngIf="hasContent" [id]="'cont'" [collapsMarker]="collapsMarker" class="item1">
    <ion-label id="collHead"><span translate>SEARCH.CONTENTS</span> ({{result.content.length}})</ion-label>
    <div id="collBody">
      <ng-template ngFor let-cont [ngForOf]="resCont | keyvalue" [ngForTrackBy]="trackByResCont">
        <coll-panel [id]="'cont_'+cont.key" [collapsMarker]="collapsMarker" [type]="'x'" class="item2">
          <mark-query id="collHead" [text]="cont.key == '' ? no_keywords : cont.key" [query]="query"></mark-query>
          <div id="collBody">
            <ng-template ngFor let-cont2 [ngForOf]="cont.value" [ngForTrackBy]="trackByCont" let-last="last">
              <coll-panel [id]="'cont2_'+cont2._id" [collapsMarker]="collapsMarker" [ngClass]="'item3' + (last ? '' : ' with-sep')"
                (headClicked)="showCont($event)" (bodyClicked)="showCont($event)">
                <mark-query id="collHead" [text]="cont2.title.de" [query]="query"></mark-query>
                <rich-text id="collBody" [text]="cont2.description.de" [query]="query" class="item-level-3"></rich-text>
              </coll-panel>
            </ng-template>
          </div>
        </coll-panel>
      </ng-template>
    </div>
  </coll-panel>

  <coll-panel *ngIf="hasQuestionChain" [id]="'quest'" [collapsMarker]="collapsMarker" class="item1">
    <ion-label id="collHead"><span translate>SEARCH.QUESTIONCHAIN</span> ({{result.questionChain.length}})</ion-label>
    <div id="collBody">
      <ng-template ngFor let-quest [ngForOf]="resQuest | keyvalue" [ngForTrackBy]="trackByResQuest">
        <coll-panel [id]="'quest_'+quest.key" [collapsMarker]="collapsMarker" [type]="'x'" class="item2">
          <mark-query id="collHead" [text]="quest.key == '' ? no_keywords : quest.key" [query]="query"></mark-query>
          <div id="collBody">
            <ng-template ngFor let-quest2 [ngForOf]="quest.value" [ngForTrackBy]="trackByQuest" let-last="last">
              <coll-panel [id]="'quest2_'+quest2.question_id" [collapsMarker]="collapsMarker" [ngClass]="'item3' + (last ? '' : ' with-sep')"
                (headClicked)="showQuest($event)" (bodyClicked)="showQuest($event)">
                <mark-query id="collHead" [text]="quest2.title.de" [query]="query"></mark-query>
                <rich-text id="collBody" [text]="quest2.description.de" [query]="query" class="item-level-3"></rich-text>
              </coll-panel>
            </ng-template>
          </div>
        </coll-panel>
      </ng-template>
    </div>
  </coll-panel>

  <coll-panel *ngIf="hasTiplist" [id]="'tiplist'" [collapsMarker]="collapsMarker" class="item1">
    <ion-label id="collHead"><span translate>SEARCH.TIPLIST</span> ({{result.tiplist.length}})</ion-label>
    <div id="collBody">
      <ng-template ngFor let-tiplist [ngForOf]="resTiplist | keyvalue" [ngForTrackBy]="trackByResTiplist">
        <coll-panel [id]="'tiplist'+tiplist.key" [collapsMarker]="collapsMarker" [type]="'x'" class="item2">
          <mark-query id="collHead" [text]="tiplist.key == '' ? no_keywords : tiplist.key" [query]="query"></mark-query>
          <div id="collBody">
            <ng-template ngFor let-tiplist2 [ngForOf]="tiplist.value" [ngForTrackBy]="trackByTiplist" let-last="last">
              <coll-panel [id]="'tiplist2_'+tiplist2._id" [collapsMarker]="collapsMarker" [ngClass]="'item3' + (last ? '' : ' with-sep')">
                <mark-query id="collHead" [text]="tiplist2.tiplist.title" [query]="query"></mark-query>
                <div id="collBody" class="item-level-3">
                  <div *ngFor="let tip of tiplist2.tiplist.tips" (click)="showTiplist(tip._id, tiplist2)">
                    <rich-text id="collBody" [text]="tip.text.de" [query]="query"></rich-text>
                  </div>
                </div>
              </coll-panel>
            </ng-template>
          </div>
        </coll-panel>
      </ng-template>
    </div>
  </coll-panel>

</ion-content>
